module.exports = __webpack_public_path__ + "img/thumbnail_BushDog_f_normal.be7045ed.png";